import { TimePickerPresetsConfig, TimePickerRangeValue } from "./time-picker.helper.ts";
import { Time } from "@/types/common.types.ts";

export enum TimePickerMode {
  single = "single",
  range = "range",
}

export interface TimePickerBaseProps {
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  className?: string;
  presets?: TimePickerPresetsConfig;
}

export interface TimePickerSingleProps extends TimePickerBaseProps {
  mode?: TimePickerMode.single;
  label?: string;
  value: Date | null;
  onChange: (value: Date) => void;
  error?: string;
  presetsTitle?: string;
  presetItems?: Time[];
  showPresets?: boolean;
  showMask?: boolean;
  withValueBackground?: boolean;
  selectTimePartOnFocus?: boolean;
  navigatePresetsWithArrows?: boolean;
}

export interface TimePickerRangeProps extends TimePickerBaseProps {
  mode: TimePickerMode.range;
  label?: string;
  value: TimePickerRangeValue;
  onChange: (value: TimePickerRangeValue) => void;
  error?: string;
  showDuration?: boolean;
  maxDurationMinutes?: number;
  startPresetsTitle?: string;
  endPresetsTitle?: string;
}

export type TimePickerProps = TimePickerSingleProps | TimePickerRangeProps;

export type { TimePickerPresetsConfig, TimePickerRangeValue } from "./time-picker.helper.ts";
